import { createContext, useState } from 'react';
import { FieldValues } from 'react-hook-form';

type AllSelectedTableItemsProviderType<TSchema extends FieldValues> = {
  allTableItemsSelected: boolean;
  setAllTableItemsSelected: React.Dispatch<React.SetStateAction<boolean>>;
  selectedTableData: TSchema[];
  setSelectedTableData: React.Dispatch<React.SetStateAction<TSchema[]>>;
};

interface AllSelectedTableItemsProviderProps {
  children: React.ReactNode;
}

// eslint-disable-next-line react-refresh/only-export-components
export function createAllSelectedTableItemsContext<
  TSchema extends FieldValues,
>() {
  return createContext<AllSelectedTableItemsProviderType<TSchema> | undefined>(
    undefined,
  );
}

export const AllSelectedTableItemsContext =
  createAllSelectedTableItemsContext<FieldValues>();

export const AllSelectedTableItemsProvider = <TSchema extends FieldValues>({
  children,
}: AllSelectedTableItemsProviderProps) => {
  const [allTableItemsSelected, setAllTableItemsSelected] =
    useState<boolean>(false);
  const [selectedTableData, setSelectedTableData] = useState<TSchema[]>([]);

  return (
    <AllSelectedTableItemsContext.Provider
      value={{
        allTableItemsSelected,
        setAllTableItemsSelected,
        selectedTableData,
        setSelectedTableData,
      }}
    >
      {children}
    </AllSelectedTableItemsContext.Provider>
  );
};
